import { ConfigOption } from '@ngx-formly/core';
import { PromotionActionDropdownComponent } from './controls/promotion-dropdowns/promotion-action-dropdown/promotion-action-dropdown.component';
import { PromotionConditionDropdownComponent } from './controls/promotion-dropdowns/promotion-condition-dropdown/promotion-condition-dropdown.component';

export const PROMOTION_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-promotion-condition-dropdown', component: PromotionConditionDropdownComponent, wrappers: ['simple-title'], },
  { name: 'formly-promotion-action-dropdown', component: PromotionActionDropdownComponent, wrappers: ['simple-title'], },
]
